import { RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

export default function CameraRadar({ data }) {
  return (
    <AnalyticsCard title="Camera Angle Coverage">
      <ResponsiveContainer width="100%" height={240}>
        <RadarChart data={data} margin={{ top: 8, right: 24, bottom: 8, left: 24 }}>
          <PolarGrid stroke="#e5e7eb" />
          <PolarAngleAxis dataKey="angle" tick={{ fontSize: 10, fill: '#7e848c' }} />
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{ fontSize: 9, fill: '#7e848c' }} tickCount={4} />
          <Radar name="Coverage %" dataKey="pct" stroke="#0066cc" fill="#0066cc" fillOpacity={0.2} strokeWidth={2} />
          <Tooltip formatter={(v) => [`${v}%`, 'Coverage']} />
        </RadarChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-4 gap-1.5 mt-2">
        {data.map((d) => (
          <div key={d.angle} className="text-center">
            <p className="text-xs font-bold text-primary">{d.pct}%</p>
            <p className="text-[10px] text-text-secondary leading-tight">{d.angle}</p>
          </div>
        ))}
      </div>
    </AnalyticsCard>
  );
}
